import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export interface ToiawaseInfo {
  id: number;
  toiawaseId: string;
  toiawaseJokyoCd: string;
  toiawaseJokyo: string;
  kjnNm: string;
  kaishaNm: string;
  email: string;
  toiawaseKenmei: string;
  toiawaseNaiyo: string;
  kaitoNaiyo: string;
  accountId: string;
  tantoNm: string;
  createdDate: string;
  updatedDate: string;
}

export type ToiawaseList = Pick<
  ToiawaseInfo,
  | "id"
  | "toiawaseId"
  | "toiawaseJokyo"
  | "createdDate"
  | "kjnNm"
  | "kaishaNm"
  | "toiawaseKenmei"
>;

export const Prop2LabelMap = {
  id: "ID",
  toiawaseId: "お問い合わせID",
  toiawaseJokyoCd: "対応状況コード",
  toiawaseJokyo: "対応状況",
  kjnNm: "氏名",
  kaishaNm: "会社名",
  email: "メールアドレス",
  toiawaseKenmei: "お問い合わせ件名",
  toiawaseNaiyo: "お問い合わせ内容",
  kaitoNaiyo: "回答内容",
  accountId: "アカウントID",
  tantoNm: "担当者名",
  createdDate: "登録日時",
  updatedDate: "更新日時",
};
export const tableHeader: TableHeaderConfig[] = [
  {
    prop: "toiawaseId",
    label: Prop2LabelMap.toiawaseId,
    width: ColWidth.md,
  },
  {
    prop: "toiawaseJokyo",
    label: Prop2LabelMap.toiawaseJokyo,
    width: ColWidth.sm,
  },
  {
    prop: "createdDate",
    label: Prop2LabelMap.createdDate,
    width: ColWidth.lg,
  },
  {
    prop: "kjnNm",
    label: Prop2LabelMap.kjnNm,
    width: ColWidth.lg,
  },
  {
    prop: "kaishaNm",
    label: Prop2LabelMap.kaishaNm,
  },
  {
    prop: "toiawaseKenmei",
    label: Prop2LabelMap.toiawaseKenmei,
  },
];
